/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/* eslint-disable */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import { toJS } from 'mobx';

const UserRoles = types.model('UserRoles', {
  tenantId: types.maybeNull(types.string),
  roles: types.optional(types.union(types.array(types.integer), types.null), [])
});

const UserDetail = types.model('UserDetail', {
  // userId: types.maybeNull(types.integer),
  userLogin: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  role: types.maybeNull(types.string),
  // roleTypeId: types.maybeNull(types.integer),
  userRoles: types.optional(types.array(UserRoles), [])
});

const ChatutilityUsers = types
  .model('ChatutilityUsers', {
    data: types.optional(types.array(UserDetail), []),
    status: types.maybeNull(types.string)
  })
  .actions((self) => ({
    fetch(searchParams = '', tenantId = '', roleId = '') {
      const dataToSend = {
        searchParams,
        tenantId,
        roleId
      };
      Framework.getEventManager().publish(constants.MANAGE_USERS_DATA_FETCHED_TENANT, dataToSend);
    },
    addUser(addUserData, tenantName) {
      Framework.getEventManager().publish(constants.ADD_USER_DATA_TENANT, { addUserData, tenantName });
    },
    updateUser(data, tenantName, tenantId) {
      Framework.getEventManager().publish(constants.EDIT_USER_DATA_TENANT, { data, tenantName, tenantId });
    },
    deleteUser(payload, tenantName) {
      Framework.getEventManager().publish(constants.DELETE_USER_DATA, { ...payload, tenantName });
    },
    addRoles(addRolesData, tenantName) {
      Framework.getEventManager().publish(constants.ADD_ROLES_DATA_TENANT, { addRolesData, tenantName });
    },
    updateRoles(addRolesData, tenantName) {
      Framework.getEventManager().publish(constants.UPDATE_ROLES_DATA_TENANT, { addRolesData, tenantName });
    },
    set(response) {
      const newData = toJS(response.data);
      applySnapshot(self.data, newData);
    },

    setAddedUserData(addedUserResponse) {
      const updatedState = toJS(self);
      updatedState.data.unshift(toJS(addedUserResponse[0]));
      applySnapshot(self, updatedState);
      Framework.getEventManager().publish(constants.SET_ADDED_DATA);
    },

    setEditUserData(addedUserResponse) {
      const updatedState = toJS(self);
      const responseemailId = addedUserResponse.data.email;
      toJS(addedUserResponse.data);
      updatedState.data = _.map(updatedState.data, (list) => {
        return list.email === responseemailId ? toJS(addedUserResponse.data) : list;
      });
      applySnapshot(self, updatedState);
      Framework.getEventManager().publish(constants.SET_UPDATED_DATA);
    },

    setDeletedUserData(email) {
      const updatedState = toJS(self);
      updatedState.data = updatedState.data.filter((list) => list.email !== email);
      applySnapshot(self, updatedState);
      Framework.getEventManager().publish(constants.SET_UPDATED_DATA);
    }
  }));

export default ChatutilityUsers;
